import { call, put, select, takeLatest } from "redux-saga/effects";
import  { fetchPitchWoOpportunity } from "../../../../services/iqApiV2";
import { FETCH_PITCH_WO_CARD_REQUEST, fetchPitchWoCardFailure, fetchPitchWoCardSuccess } from "../../actions/opportunities/pitchCardWOActions";


// Worker Saga
function* fetchpitchWoSaga() {
  try {
    const payload = yield select(
      (state) => state?.pitchWoReducer?.payload
    );
    const { opportunityId } = payload;
    const data = yield call(
       fetchPitchWoOpportunity,
       opportunityId
    );
    yield put(fetchPitchWoCardSuccess(data));
  } catch (error) {
    yield put(fetchPitchWoCardFailure(error.message));
  }
}

// Watcher Saga
export function* watchpitchWoData() {
  yield takeLatest(FETCH_PITCH_WO_CARD_REQUEST, fetchpitchWoSaga);
}
